export default __webpack_public_path__ + "924777b0848cd56ff977cd600cbe5bb1.svg";